<template>
  <div class="map-container">
    <loading
      :active.sync="isLoading"
      :is-full-page="fullPage"
      loader="bars"
    ></loading>
    <div ref="map" class="map" style="height: 100%; width: 100%"></div>
    <div class="control-layer">
      <div class="d-flex align-items-center py-1">
        <input
          type="checkbox"
          name="devices_show"
          id="devices_show"
          @change="devices_visibility = !devices_visibility"
          :checked="devices_visibility"
          class="mr-2"
        />
        {{ $t("devices") }}
      </div>
      <div class="d-flex align-items-center py-1">
        <input
          type="checkbox"
          name="POI_show"
          id="POI_show"
          @change="POI_visibility = !POI_visibility"
          class="mr-2"
          :checked="POI_visibility"
        />
        POI
      </div>
      <div class="d-flex align-items-center py-1">
        <input
          type="checkbox"
          name="geofence_show"
          id="geofence_show"
          @change="geofence_visibility = !geofence_visibility"
          class="mr-2"
          :checked="geofence_visibility"
        />
        {{ $t("geo") }}
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import loadGoogleMapsApi from "load-google-maps-api";
import stableDeviceIcon from "../../assets/images/marker-good.svg";
import criticalDeviceIcon from "../../assets/images/marker-critical.svg";
import poiIcon from "../../assets/images/home.svg";

export default {
  name: "LiveMap",
  components: {
    Loading,
  },
  props: {
    devices: Array,
    POIname: String,
    addpoi: Boolean,
    POI: Array,
    geofencename: String,
    geofencecolor: String,
    addgeofence: Boolean,
    geofence: Array,
    POIhandler: Boolean,
    geofencehandler: Boolean,
    editPOI: Object,
    selectedPOI: Array,
  },
  data() {
    return {
      map: null,
      markers: [],
      polygons: [],
      isLoading: false,
      fullPage: true,
      devices_visibility: true,
      POI_visibility: false,
      geofence_visibility: false,
      googleMap_visibility: true,
      openStreetMap_visibility: false,
      showMap: false,
    };
  },
  computed: {
    filteredDevices() {
      return this.devices.filter(
        (device) => device.stat && device.stat.validLocation
      );
    },
  },
  watch: {
    devices: {
      handler: function () {
        this.updateMarkers();
      },
      deep: true,
    },
    POI: {
      handler: function () {
        if (this.selectedPOI.length === 0) {
          this.updateMarkers();
        }
      },
      deep: true,
    },
    geofence: {
      handler: function () {
        this.updatePolygons();
        this.updateBounds();
      },
      deep: true,
    },
    devices_visibility() {
      this.updateMarkers();
    },
    POI_visibility() {
      this.updateMarkers();
    },
    geofence_visibility() {
      this.updatePolygons();
      this.updateBounds();
    },
    selectedPOI: {
      handler(val) {
        console.log(val.length, "val");
        if (val.length === 0) {
          this.POI_visibility = false;
          this.updateMarkers();
        } else {
          const { google } = window;
          const bounds = new google.maps.LatLngBounds();
          this.POI_visibility = true;

          // Remove existing POI markers from the map
          this.markers.forEach((marker) => {
            if (marker.getIcon().url === poiIcon) {
              marker.setMap(null);
            }
          });

          // Filter out the POI markers from the markers array
          this.markers = this.markers.filter(
            (marker) => marker.getIcon().url !== poiIcon
          );

          // Add new POI markers for the selected POIs
          this.selectedPOI.forEach((markerData, index) => {
            const marker = new google.maps.Marker({
              position: {
                lat: +markerData.position.lat,
                lng: +markerData.position.lng,
              },

              map: this.map,
              icon: {
                url: poiIcon,
                scaledSize: new google.maps.Size(40, 40),
              },
            });

            const infowindow = new google.maps.InfoWindow({
              content: markerData.name,
            });

            marker.addListener("click", () => {
              infowindow.open(this.map, marker);
            });

            bounds.extend({
              lat: +markerData.position.lat,
              lng: +markerData.position.lng,
            });

            this.markers.push(marker);
          });

          if (!bounds.isEmpty()) {
            this.map.fitBounds(bounds);
          }
        }
      },
      deep: true,
    },
  },
  mounted() {
    // this.initMap();
    loadGoogleMapsApi({
      key: process.env.VUE_APP_GOOGLE_API_KEY,
      libraries: ["places", "drawing", "geometry"],
    }).then(async () => {
      // this.initializeMap();
      this.initMap();
    });
  },
  methods: {
    ...mapActions(["addPOI", "editpoi"]),
    initMap() {
      const { google } = window;
      const mapZoom = 4;
      const mapOptions = {
        zoom: mapZoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        fullscreenControl: true,
        fullscreenControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_RIGHT,
        },
        center: new google.maps.LatLng({ lat: 23, lng: 57 }),
        mapTypeControl: true,
        streetViewControl: false,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.BOTTOM_LEFT,
        },
      };
      this.map = new google.maps.Map(this.$refs.map, mapOptions);

      this.map.addListener("click", this.clickMap);

      this.updateMarkers();
      this.updatePolygons();
      this.updateBounds();
    },
    updateBounds() {
      const { google } = window;
      const bounds = new google.maps.LatLngBounds();

      if (this.devices_visibility) {
        this.filteredDevices.forEach((device) => {
          bounds.extend({
            lat: +device.stat.latitude,
            lng: +device.stat.longitude,
          });
        });
      }

      if (this.POI_visibility) {
        const data = this.selectedPOI.length > 0 ? this.selectedPOI : this.POI;
        data.forEach((markerData) => {
          bounds.extend({
            lat: +markerData.position.lat,
            lng: +markerData.position.lng,
          });
        });
      
        
      }

      if (this.geofence_visibility) {
        this.geofence.forEach(({ latlngs }) => {
          latlngs.forEach((latlng) => {
            bounds.extend(latlng);
          });
        });
      }

      console.log("bounds updated", bounds);

      if (bounds.isEmpty()) {
        // If bounds are empty (no markers or polygons), set default center and zoom
        this.map.setCenter({ lat: 6.765, lng: 3.428 });
        this.map.setZoom(10);
      } else {
        // Fit the map to the bounds
        this.map.fitBounds(bounds);
      }
    },

    updateMarkers() {
      const { google } = window;

      // Clear existing markers
      this.markers.forEach((marker) => marker.setMap(null));
      this.markers = [];
      if (this.devices_visibility) {
        this.filteredDevices.forEach((device) => {
          const marker = new google.maps.Marker({
            position: {
              lat: +device.stat.latitude,
              lng: +device.stat.longitude,
            },
            map: this.map,
            icon: {
              url:
                device.status === "stable"
                  ? stableDeviceIcon
                  : criticalDeviceIcon,
              scaledSize: new google.maps.Size(40, 40),
            },
          });

          const infowindow = new google.maps.InfoWindow({
            content: `
              <div class="p-2">
                <div class="font-bold mb-2">${device.settings.name}</div>
                <div>${this.$t("temp")}: ${device.stat.temperature}</div>
                ${
                  device.type === "mote" || device.type === "gps-vt"
                    ? `${this.$t("humid")}: ${device.stat.humidity}`
                    : ""
                }
              </div>
            `,
          });

          marker.addListener("click", () => {
            infowindow.open(this.map, marker);
          });

          this.markers.push(marker);
        });
      }

      if (this.POI_visibility) {
        const data = this.selectedPOI.length > 0 ? this.selectedPOI : this.POI;
        data.forEach((markerData, index) => {
          const marker = new google.maps.Marker({
            position: {
              lat: +markerData.position.lat,
              lng: +markerData.position.lng,
            },

            map: this.map,
            icon: {
              url: poiIcon,
              scaledSize: new google.maps.Size(40, 40),
            },
          });

          const infowindow = new google.maps.InfoWindow({
            content: markerData.name,
          });

          marker.addListener("click", () => {
            infowindow.open(this.map, marker);
          });

          this.markers.push(marker);
        });
      }
      this.updateBounds();
    },
    updatePolygons() {
      const { google } = window;

      // Clear existing polygons
      this.polygons.forEach((polygon) => polygon.setMap(null));
      this.polygons = [];

      if (this.geofence_visibility) {
        this.geofence.forEach(({ latlngs, color, name }) => {
          const polygon = new google.maps.Polygon({
            paths: latlngs,
            strokeColor: color,
            strokeWeight: 3,
            fillColor: color,
            fillOpacity: 0.3,
            map: this.map,
            label: name,
            zIndex: 99,
            editable: false,
            draggable: false,
          });

          const infowindow = new google.maps.InfoWindow({
            content: name,
          });

          polygon.addListener("click", (event) => {
            infowindow.setPosition(event.latLng);
            infowindow.open(this.map);
          });

          this.polygons.push(polygon);

          // Optionally, fit the map bounds to show all polygons
          if (this.polygons.length > 0) {
            const bounds = new google.maps.LatLngBounds();
            this.polygons.forEach((polygon) => {
              if (polygon.getPath()) {
                polygon.getPath().forEach((latlng) => {
                  bounds.extend(latlng);
                });
              }
            });
            this.map.fitBounds(bounds);
          }
        });
      }
    },
    toggleMap() {
      if (this.googleMap_visibility) {
        this.map.setMapTypeId("roadmap");
        this.googleMap_visibility = false;
        this.openStreetMap_visibility = true;
      } else {
        this.map.setMapTypeId("hybrid");
        this.googleMap_visibility = true;
        this.openStreetMap_visibility = false;
      }
    },
    clickMap(event) {
      const { lat, lng } = event.latLng.toJSON();
      if (this.addpoi) {
        this.isLoading = true;
        const newMarker = {
          position: { lat, lng },
          name: this.POIname,
        };

        if (this.editPOI.id) {
          this.editpoi({ POI: newMarker, id: this.editPOI.id })
            .then((res) => {
              const data = res.data.payload;
              // this.POI.push(newMarker);
              this.isLoading = false;
              this.$emit("poi-edited", data);
            })
            .catch((err) => console.error(err));
        } else {
          this.addPOI({ POI: newMarker })
            .then(() => {
              this.POI.push(newMarker);
              this.isLoading = false;
              this.$emit("poi-added");
            })
            .catch((err) => console.error(err));
        }
      } else if (this.addgeofence) {
        const index = this.geofence.length - 1;
        this.geofence[index].latlngs.push([lat, lng]);
        if (this.geofence[index].latlngs.length === 1) {
          this.$emit("geofence-firstclick");
        } else if (this.geofence[index].latlngs.length === 2) {
          this.$emit("geofence-secondclick");
        }
      }
    },
    viewdevice(device) {
      setTimeout(() => {
        this.map.setCenter({
          lat: device.stat.latitude,
          lng: device.stat.longitude,
        });
        this.map.setZoom(15);
      }, 600);
    },
  },
};
</script>

<style scoped>
.map-container {
  position: relative;
  height: 100%;
  width: 100%;
}

.map {
  height: 100%;
  width: 100%;
}

.control-layer {
  position: absolute;
  top: 10px;
  right: 10px;
  background: white;
  padding: 10px;
  z-index: 1000;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}

.mr-2 {
  margin-right: 0.5rem;
}
</style>

<i18n>
{
	"en": {
		"google_map": "Google Map",
		"open_str": "Open Street Map"
	},
	"es": {
		"google_map": "Mapa de Google",
		"open_str": "Abrir mapa de calles"
	},
	"fr": {
		"google_map": "Google Map",
		"open_str": "Ouvrir la carte des rues"
	},
	"sw": {
		"google_map": "Ramani ya Google",
		"open_str": "Fungua Ramani ya Mtaa"
	}
}
</i18n>
